/**
 * OUTFIT — Skimlinks Service
 * Publisher ID : 301454X1789418
 *
 * Ce qui fonctionne MAINTENANT :
 * ✓ Link Wrapper  → convertit n'importe quelle URL en lien affilié tracké
 *
 * En attente :
 * ○ Product Key API → demander à hub.skimlinks.com → Toolbox → Product Key
 */

const SKIMLINKS_PUB_ID = '301454X1789418';

/* ══════════════════════════════════════════════════════════
   1. CONVERTIR UN LIEN EN LIEN AFFILIÉ TRACKÉ
══════════════════════════════════════════════════════════ */
export function buildSkimlinksUrl(originalUrl, options) {
  if (!originalUrl) return originalUrl;
  options = options || {};

  var userId    = options.userId    || '';
  var productId = options.productId || '';

  var parts = [];
  if (userId)    parts.push(userId);
  if (productId) parts.push(productId);
  parts.push(String(Date.now()));
  var xcust = parts.join('_').slice(0, 50);

  var url = 'https://go.redirectingat.com/?id=' + SKIMLINKS_PUB_ID
    + '&url=' + encodeURIComponent(originalUrl)
    + (xcust ? '&xcust=' + encodeURIComponent(xcust) : '');

  return url;
}

/* ══════════════════════════════════════════════════════════
   2. APPLIQUER SKIMLINKS SUR UNE LISTE DE PRODUITS
══════════════════════════════════════════════════════════ */
export function applySkimlinksToProducts(products, userId) {
  userId = userId || '';
  if (!Array.isArray(products)) return products;

  // Partenaires qui ont leur propre tracking : ne pas wrapper Skimlinks (sinon double-tracking et Rakuten/CJ perdent l'attribution)
  // v1.12.298 — ajout suit_negozi (Rakuten LinkShare deep-link déjà tracké via affiliateUrl)
  // v1.12.322 — ajout ann_demeulemeester (Rakuten Advertising aussi)
  // v1.12.336 — ajout coutr (Rakuten Advertising, USD)
  const CJ_PARTNERS = ['cashmere', 'iqueens', 'tous', 'suit_negozi', 'ann_demeulemeester', 'coutr'];

  return products.map(function(p) {
    // Skip Skimlinks si le produit a déjà son propre tracking CJ
    if (CJ_PARTNERS.indexOf(p.partner) !== -1) {
      return p; // garde l'affiliateUrl CJ intact
    }
    var directUrl = p.originalUrl;
    if (!directUrl || !directUrl.startsWith('http')) {
      return p;
    }
    return Object.assign({}, p, {
      affiliateUrl: buildSkimlinksUrl(directUrl, {
        userId:    userId,
        productId: p.zalandoSku || p.zaraId || p.id || '',
      }),
      trackedVia: 'skimlinks',
    });
  });
}

/* ══════════════════════════════════════════════════════════
   3. MERCHANT API
══════════════════════════════════════════════════════════ */
export async function getSkimlinksMerchants(category) {
  category = category || 'fashion';
  try {
    var res = await fetch(
      'https://merchants.skimlinks.com/merchants?pubId=' + SKIMLINKS_PUB_ID + '&category=' + category + '&limit=20',
      { headers: { 'Accept': 'application/json' } }
    );
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.json();
  } catch (e) {
    console.warn('Skimlinks merchants:', e.message);
    return [];
  }
}

/* ══════════════════════════════════════════════════════════
   4. REPORTING API
══════════════════════════════════════════════════════════ */
export async function getSkimlinksTransactions(dateFrom, dateTo, clientId, clientSecret) {
  if (!clientId || !clientSecret) {
    console.warn('Skimlinks: Client ID/Secret requis');
    return [];
  }
  try {
    var authRes = await fetch('https://authentication.skimlinks.com/oauth2/token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'grant_type=client_credentials'
        + '&client_id=' + encodeURIComponent(clientId)
        + '&client_secret=' + encodeURIComponent(clientSecret)
        + '&scope=reporting:read',
    });
    if (!authRes.ok) throw new Error('Auth ' + authRes.status);
    var authData = await authRes.json();
    var token = authData.access_token;

    var txRes = await fetch(
      'https://api.skimlinks.com/reporting/transactions?start=' + dateFrom + '&end=' + dateTo,
      { headers: { 'Authorization': 'Bearer ' + token } }
    );
    if (!txRes.ok) throw new Error('Reporting ' + txRes.status);
    var data = await txRes.json();
    return data.transactions || data || [];
  } catch (e) {
    console.warn('Skimlinks transactions:', e.message);
    return [];
  }
}

/* ══════════════════════════════════════════════════════════
   5. PRODUCT KEY (à activer quand l'accès est accordé)
══════════════════════════════════════════════════════════ */
export async function searchSkimlinksProducts(keyword, options) {
  console.info('Skimlinks Product Key non encore activé');
  return [];
}

export async function getSkimlinksProducts(gender, category, limit) {
  return [];
}
